import { render, staticRenderFns } from "./Cosecha.vue?vue&type=template&id=6cdb317a"
import script from "./Cosecha.vue?vue&type=script&lang=js"
export * from "./Cosecha.vue?vue&type=script&lang=js"
import style0 from "./Cosecha.vue?vue&type=style&index=0&id=6cdb317a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports